import { Component, OnInit, HostBinding } from '@angular/core';
import { UpdateService, SetData } from './update.service';
import { TabsService } from '../home/tabs.service';
import { ProjectService } from 'dbweb-core';
import { Subscription } from 'rxjs';

@Component({
	selector: 'common-update',
	templateUrl: './update.component.html',
	styleUrls: ['./update.component.scss']
})
export class UpdateComponent implements OnInit {
	@HostBinding('class.update') hostClass = true;
	subs: Subscription[] = [];
	constructor(public srv: UpdateService, private tabs: TabsService, public prj: ProjectService) {}

	ngOnInit() {
		this.srv.init();
	}

	doUpdate() {
		const sets: SetData[] = this.srv.fields
			.filter(v => v.selected)
			.map(v => ({ Column: v.Name, Value: v.setValue }));

		this.srv.doUpdate({ Sets: sets }).subscribe(v => {
			this.srv.step = 'complete';
			this.srv.taskInfoURL = this.prj.frontURL('task', v.TaskInfoURL);
		});
	}
	close() {
		this.tabs.close();
	}
	quantityToReplace(): number {
		let num = 0;
		if (this.srv.fields) {
			this.srv.fields.forEach(item => {
				if (item.selected || item.Must) {
					num++;
				}
			});
		}
		return num;
	}
}
